




































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user/user.store';
import { ApiPermissions } from '@/core/security/Permissions';
import dateFormat from '@/plugins/filters/dateFormat.filter';

import EditIngamePassword from './EditIngamePassword.vue';
import { ModalConstants } from '@/core/constants';
import { AccountViewObject } from '@/types/apiServerContract';

@Component({
    components: { EditIngamePassword }
})
export default class EditIngameAccount extends Vue {
	@Prop()
	account!: AccountViewObject;

	permissions: string[] = [ApiPermissions.User.EditIngameAccount];
	profile: AccountViewObject = Object.assign({}, this.account);
	loading: boolean = false;

	get CanUpdatePassword() {
	    return UserModule.user?.HasPermission([ApiPermissions.User.EditIngameAccountPassword]);
	}

	ShowPasswordOverlay() {
	    this.$bvModal.show(ModalConstants.ChangeIngamePassword);
	}

	async UpdateAccount() {}

	GetDate(date: Date) {
	    return dateFormat(date);
	}

	Reset() {
	    this.profile = Object.assign({}, this.account);
	}
}
